<template>
  <div class="layout">
    <div style="text-align:center">
      <h3>{{ $t('estimate_confirmed') }}</h3>
      <button class="btn" @click="$router.push({ name: 'Estimate', params: { code: $route.params.code } });">
        {{ $t('view_accepted_estimate') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Success"
};
</script>


<style scoped>

.btn {
  background-color: #ff6a00;
  border: none;
  padding: 1rem;
  color: #fff;
  flex-grow: 1;
  margin: 10px;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.3s;
}

.btn:hover {
  transform: scale(1.03);
}
  .layout {
    min-height: 100vh;
    background-color: #f2f2f2;
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-template-areas: "contents";
  }

.content {
  grid-area: contents;
  display: flex;
  justify-content: center;
}

.section {
  flex-wrap: wrap;
  display: flex;
  background-color: #fff;
  max-width: 800px;
  align-content: baseline;
  box-shadow: 0px 0px 15px #d4d4d4;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 4rem;
}

.item {
  min-width: 300px;
  padding: 1rem;
  flex-grow: 1;
  display: flex;
  flex-flow: column;
}

.item.large {
  width: 100%;
}
</style>
